module.exports = __webpack_public_path__ + "static/media/aap.2e9d9714.svg";